angular.module('callX').service('MailChimpService', ['$http', '$rootScope', 'UserService',
  function ($http){

    var sendCode = function(id, accessCode, callbacks){
      $http.post("/japi/mailchimp/"+id+"/requestToken?accesscode="+accessCode)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getUserCode = function(callbacks){
      $http.get("/japi/user/0")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

     var getList = function(id, callbacks){
      $http.get("/japi/mailchimp/"+id+"/getlist")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var deleteIntegration = function(id, callbacks){
      $http.delete("/japi/mailchimp/deactivate/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var deleteSelected = function(id,sId,callbacks){
      $http.delete("/japi/mailchimp/"+id+"?campaignid="+sId)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getStatus = function(id, callbacks){
      $http.get("/japi/mailchimp/publisher/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getCampaignsList = function(callbacks){
      $http.get("/japi/campaign/campaign?status=publisher")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    
    var postList = function(pubId,campaignId,listId,listWebId,name,callbacks){
      $http.post("/japi/mailchimp/"+pubId+"?campaignid="+campaignId+"&listid="+listId+"&webid="+listWebId+"&name="+name)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getSelectedList = function(pubId,callbacks){
      $http.get("/japi/mailchimp/"+pubId+"/selectedlist")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    return {
      sendCode: function (id, accessCode, callbacks) {
        sendCode(id, accessCode, callbacks);
      },
      getList: function (id, callbacks) {
        getList(id, callbacks);
      },
      getUserCode: function (callbacks) {
        getUserCode(callbacks);
      },
      deleteIntegration: function (id, callbacks) {
        deleteIntegration(id, callbacks);
      },
      deleteSelected: function (id,sId, callbacks) {
        deleteSelected(id,sId, callbacks);
      },
      getStatus: function (id, callbacks) {
        getStatus(id, callbacks);
      },
      getCampaignsList: function (callbacks) {
        getCampaignsList(callbacks);
      },
      postList: function (pubId,campaignId,listId,listWebId,name,callbacks) {
        postList(pubId,campaignId,listId,listWebId,name,callbacks);
      },
      getSelectedList: function (pubId,callbacks) {
        getSelectedList(pubId,callbacks);
      }
    };
  }]);